// extracted by mini-css-extract-plugin
export default {"youTubeVideo":"youTubeVideo___A3d-c","playButton":"playButton___3CTtF","videoEnabledJs":"videoEnabledJs___J302B"};